export default {
      id: "icon-basetarif-usage",
      viewBox: "0 0 56 66",
      url: __webpack_public_path__ + "icons.svg#icon-basetarif",
      toString: function () {
        return this.url;
      }
    }